import React from 'react';
import { Box } from '@mui/material';

import { AngleField, DistanceField } from '@paragon/material';

import { updateShapeDetailsAndRegenerateTruss } from '../../../../../../store/actions/insertComponentDesignActions';
import { JackShapeDetails as JackShapeDetailsInterface } from '../../../../../../store/slices/applicationSlice';
import { useAppDispatch } from '../../../../../hooks';
import { LabeledBox } from '../../../properties/LabeledBox';
import { OverhangSettings } from '../../../properties/OverhangSettings';
import { createExceedsMaxLengthErrorAction, exceedsMaxLength, minTrussLength } from './Length';
import { ShapeDetailsHeelSettings } from './ShapeDetailsHeelSettings';

const textFieldSx = { m: 1, flex: 1 } as const;

interface Props {
  readonly shapeDetails: JackShapeDetailsInterface;
}

export function JackShapeDetails({ shapeDetails }: Props) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <DistanceField
          label="Length"
          value={shapeDetails.span}
          min={minTrussLength}
          onSubmit={async (value) => {
            if (exceedsMaxLength(value)) {
              dispatch(createExceedsMaxLengthErrorAction());
              return;
            }

            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, span: value }));
          }}
          sx={textFieldSx}
        />
        <AngleField
          label="Slope"
          sx={textFieldSx}
          value={shapeDetails.slopeInDegrees}
          defaultDisplayFormat="slope"
          onSubmit={async (value) => {
            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, slopeInDegrees: value }));
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <LabeledBox title="Heel">
          <ShapeDetailsHeelSettings
            heelSettings={shapeDetails.leftHeelSettings}
            topChordSlopeInDegrees={shapeDetails.slopeInDegrees}
            onChange={async (value) => {
              await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, leftHeelSettings: value }));
            }}
          />
        </LabeledBox>

        <LabeledBox title="Overhang">
          <OverhangSettings
            overhangSettings={shapeDetails.leftOverhang}
            onChange={async (value) => {
              await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, leftOverhang: value }));
            }}
          />
        </LabeledBox>
      </Box>
    </>
  );
}
